// extracted by mini-css-extract-plugin
module.exports = {"tabList":"TabList_tabList__Cly5W","underline":"TabList_underline__JwjXN","segmented":"TabList_segmented__wWF8n"};